import React, {Component} from 'react';
import {Button, Form} from 'react-bootstrap'
import DrawerMenu from '../DrawerMenu'
import {Route} from 'react-router'
import ApiManager from '../../ApiManager'
import {withRouter, BrowserRouter, Switch, Redirect} from 'react-router-dom'
class ObjectCraneScreen extends React.Component {
  constructor(props){
    super(props)
    var month = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
    var year = new Date().getFullYear();
    var day = new Date().getDay() < 10 ? "0" + new Date().getDay() : new Date().getDay()
      this.state = {
          isProcessing: false,
          date_start: year + "-" + month + "-" + day,
          date_end: year + "-" + month + "-" + day,
          crane_id: 0,
          object_id: 0,
          status: 0,
          cranes: []
      }
  }
    handleChange(value, formattedValue) {
    /*this.setState({
      value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      formattedValue: formattedValue // Formatted String, ex: "11/19/2016"
    });*/
  }
  componentDidMount(){
      ApiManager.fetchCranes().then(response => {
          this.setState({cranes: response.data})
      })
      if (this.props.type == "edit"){
          ApiManager.getItem("objects_cranes", this.props.id).then(item => {
              this.setState({
                  crane_id: item.data.crane_id,
                  date_start: item.data.date_start,
                  date_end: item.data.date_end,
                  object_id: item.data.object_id,
                  status: item.data.status
              })
          })
      }
      else{
          this.setState({
              object_id: this.props.object_id
          })
      }
  }
  addOrUpdate(){
      var data = new FormData()
      data.append("table", "objects_cranes")
      data.append("date_start", this.state.date_start)
      data.append("date_end", this.state.date_end)
      data.append("status", this.state.status)
      data.append("crane_id", this.state.crane_id)
      data.append("object_id", this.state.object_id)
      this.setState({isProcessing: true})
      if (this.props.type == "add"){
          ApiManager.addItem2(data).then(response => {
this.props.history.goBack()
          })
      }
      else{
          data.append("id", this.props.id)
          ApiManager.updateItem2(data).then(response => {
this.props.history.goBack()
})
      }
  }
  render() {
    var AddBtnTitle = this.state.isProcessing ? <span><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Пожалуйста, подождите</span> : <span>{this.props.type == "add" ? "Добавить" : "Сохранить"} </span>
    var CraneListData = this.state.cranes.map(crane => {
        return <option value={crane.id}>{crane.name}</option>
    })
    return (
        <div style={{margin: "0 auto", width: '50%'}}>
<Form>
  <Form.Group controlId="exampleForm.ControlSelect1">
    <Form.Label>Кран</Form.Label>
    <Form.Control as="select" value={this.state.crane_id} onChange={event => this.setState({crane_id: event.target.value})}>
      <option value="0">Не выбран</option>
      {CraneListData}
    </Form.Control>
  </Form.Group>
  <Form.Group controlId="exampleForm.ControlInput1">
    <Form.Label>Дата монтажа</Form.Label>
    <Form.Control type="date" placeholder="" value={this.state.date_start} required onChange={event => this.setState({date_start: event.target.value})}/>
  </Form.Group>
  <Form.Group controlId="exampleForm.ControlInput1">
    <Form.Label>Дата демонтажа</Form.Label>
    <Form.Control type="date" placeholder="" value={this.state.date_end} required onChange={event => this.setState({date_end: event.target.value})}/>
  </Form.Group>
  <Form.Group controlId="exampleForm.ControlSelect1">
    <Form.Label>Статус</Form.Label>
    <Form.Control as="select" value={this.state.status} onChange={event => this.setState({status: event.target.value})}>
      <option value="0">Не выбран</option>
      <option value="1">Отсутсвует на объекте</option>
      <option value="2">Завезен на площадку</option>
      <option value="4">Идет монтаж крана</option>
      <option value="8">Смонтирован и не запущен</option>
      <option value="16">Смонтирован и работает</option>
      <option value="32">Смонтирован и остановлен</option>
      <option value="64">Идет демонтаж крана</option>
      <option value="128">Демонтирован и не вывезен</option>
      <option value="256">Вывезен с объекта</option>
    </Form.Control>
  </Form.Group>
       <Button style={{width: '300px', paddingTop: '8px', marginBottom: '16px'}} variant="primary" onClick={() => this.addOrUpdate()}>
  {AddBtnTitle}
 </Button>
</Form>
        </div>
    );
  }
}
export default withRouter(ObjectCraneScreen);